var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-inline-container"
  }, [_c('div', {
    staticClass: "kiwi-inline-header"
  }, [_c('div', {
    staticClass: "kiwi-inline-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "kiwi-inline-controls"
  }, [_vm.showSettings ? _c('button', {
    staticClass: "kiwi-inline-settings",
    on: {
      "click": _vm.toggleSettings
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })]) : _vm._e()])]), _c('div', {
    staticClass: "kiwi-inline-content"
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };